/** Read-only adapter for the existing advisor spending scenario. No new model. */
export interface UiForecast {
  curveCents: number[];
  endpointCents: number;
  cashRunwayDays: number | null;
}
export function projectForecast(value: unknown): UiForecast | null {
  if (typeof value !== 'object' || value === null) return null;
  const r = value as Record<string, unknown>;
  const curve = r['forecastCurveCents'];
  if (!Array.isArray(curve) || curve.length < 2 || !curve.every((v: unknown) => typeof v === 'number' && Number.isFinite(v))) return null;
  if (typeof r['forecastCents'] !== 'number' || !Number.isFinite(r['forecastCents'])) return null;
  const runway = r['cashRunwayDays'];
  if (runway !== null && (typeof runway !== 'number' || !Number.isFinite(runway))) return null;
  return { curveCents: (curve as number[]).slice(), endpointCents: r['forecastCents'], cashRunwayDays: runway };
}
